"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useDataGridCell_unstable", {
    enumerable: true,
    get: ()=>useDataGridCell_unstable
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _useTableCell = require("../TableCell/useTableCell");
const _dataGridContext = require("../../contexts/dataGridContext");
const _columnIdContext = require("../../contexts/columnIdContext");
const useDataGridCell_unstable = (props, ref)=>{
    const columnId = (0, _columnIdContext.useColumnIdContext)();
    const tabbable = (0, _dataGridContext.useDataGridContext_unstable)((ctx)=>ctx.focusMode === 'cell');
    const resizableColumns = (0, _dataGridContext.useDataGridContext_unstable)((ctx)=>ctx.resizableColumns);
    const columnSizing = (0, _dataGridContext.useDataGridContext_unstable)((ctx)=>ctx.columnSizing_unstable);
    return (0, _useTableCell.useTableCell_unstable)({
        as: 'div',
        role: 'gridcell',
        tabIndex: tabbable ? 0 : undefined,
        ...resizableColumns ? columnSizing.getTableCellProps(columnId) : {},
        ...props
    }, ref);
}; //# sourceMappingURL=useDataGridCell.js.map

//# sourceMappingURL=useDataGridCell.js.map